// Configuration API - Détection automatique du backend
const getApiUrl = () => {
  if (process.env.REACT_APP_BACKEND_URL) {
    return `${process.env.REACT_APP_BACKEND_URL}/api`;
  }
  return `${window.location.origin}/api`;
};

export const API = getApiUrl();
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;
